module.exports = {"140902001":"秀容街道","140902002":"长征街街道","140902003":"新建路街道","140902004":"云中路街道","140902005":"九原街街道","140902006":"旭来街街道","140902007":"桥西街街道","140902101":"奇村镇","140902102":"三交镇","140902103":"庄磨镇","140902104":"豆罗镇","140902105":"董村镇","140902106":"西张镇","140902107":"忻口镇","140902108":"合索镇","140902206":"兰村乡","140902209":"东楼乡","140902210":"北义井乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140902.json
// module id = 434
// module chunks = 0